<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-11 router-view-background">
    <birth-filters />
    <births-list />
  </div>
</template>

<script>
import BirthFilters from "./BirthFilters.vue";
import BirthsList from "./BirthsList.vue";
export default {
  name:"BirthConsultation",
  components: {
    BirthFilters,
    BirthsList
  }
}
</script>

<style>

</style>